/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ChevronsVertical({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M7.576 3.076a.6.6 0 0 1 .848 0l3 3a.6.6 0 0 1-.848.848L8 4.35 5.424 6.924a.6.6 0 0 1-.848-.848zm-3 6a.6.6 0 0 1 .848 0L8 11.652l2.576-2.576a.6.6 0 0 1 .848.848l-3 3a.6.6 0 0 1-.848 0l-3-3a.6.6 0 0 1 0-.848" clipRule="evenodd" /></svg>;
}
;